export default __webpack_public_path__ + "static/media/bag.e65e8113.png";